import { superstyled } from '@zenbusiness/zui/styles';
import Text from '@zenbusiness/zui/Text';

export const TOOLTIP_SLOT_PROPS = {
  tooltip: {
    sx: {
      borderRadius: '1rem',
      fontSize: '0.875rem',
      padding: '1rem',
    },
  },
};

export const TruncatedText = superstyled({
  tag: Text,
  name: 'OverflowText',
  slot: 'TruncatedText',
  styles: {
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
  },
});
